import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, change, changeType, icon, iconColor, iconBg }) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'var(--color-success)';
    if (changeType === 'negative') return 'var(--color-error)';
    return 'var(--color-muted-foreground)';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div className="card">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="text-sm text-muted-foreground mb-1 font-caption">{title}</p>
          <p className="text-3xl font-bold text-foreground font-heading">{value}</p>
        </div>
        <div 
          className="h-12 w-12 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: iconBg }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
      </div>
      
      {change && (
        <div className="flex items-center gap-2">
          <Icon name={getChangeIcon()} size={16} color={getChangeColor()} />
          <span className="text-sm font-medium font-data" style={{ color: getChangeColor() }}>
            {change}
          </span>
          <span className="text-xs text-muted-foreground font-caption">vs last month</span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;